import * as React from 'react';
import { styled, width } from '@mui/system';
import { Stepper, Step, StepLabel, StepConnector } from '@mui/material';

// Custom reusable stepper component
const CustomStepper = ({ steps, activeStep, content, connectorColor = '#000', circleColor = '#000', marginTop = 0, marginBottom = 0 }) => {
    // Styled connector
    const CustomConnector = styled(StepConnector)(({ theme }) => ({
        '&.MuiStepConnector-root': {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
            // minWidth: 50,
            // maxWidth: 50,
        },
        '& .MuiStepConnector-line': {
            px: 2,
            // minWidth: 50,
            // maxWidth: 50,
        },
    }));

    // Styled step icon
    const CustomStepIcon = styled('div')(({ theme, ownerState }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: ownerState.completed
            ? '#000' // Black background for completed steps
            : ownerState.active
                ? circleColor
                : '#E0E0E0', // Default background for inactive steps
        color: ownerState.completed ? '#FFF' : ownerState.active ? '#FFF' : '#808588', // White icon for completed/active steps
        fontWeight: 600,
    }));

    return (
        <Stepper
            alternativeLabel={window?.innerWidth <= 768 ? true : false}
            activeStep={activeStep} connector={<CustomConnector />} sx={{ marginTop: marginTop, marginBottom: marginBottom, overflow: 'auto' }}>
            {steps.map((label, index) => (
                <Step key={label}>
                    <StepLabel
                        StepIconComponent={(props) => (
                            <CustomStepIcon ownerState={{ active: props.active, completed: props.completed }}>
                                {props.completed ? < i className="ri-check-line"></i> : index + 1} {/* Show tick icon if completed */}
                            </CustomStepIcon>
                        )}
                    >
                        <span className='font-size-13'>{label}</span>
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
};

export default CustomStepper;